import React from "react";
import AgentsV2 from "./agentsv2";
import Martha from "../../../../public/img/martha-turner/logo_black.png";
import Equestrian from "../../../../public/img/equestrian/logo_black.png";
import Sirblack from "../../../../public/img/SIR_logo_Black.png";
import Disclaimer from "../../shared/footer/disclaimer";

const FooterV2 = (props) => {
  let listing = props.listing;
  let isHouston = listing && listing.regionUrlPart === "houston";
  // atlasOfficeId 157
  let logoSrc =
    props.officeId === "c0c006f4-5237-4565-b90e-8411c757b966"
      ? Equestrian
      : isHouston
      ? Martha
      : Sirblack;
  let officeContact;

  if (listing.source === "global") {
    officeContact =
      listing.office &&
      listing.office.courtesyOf &&
      listing.office.courtesyOf[0]
        ? listing.office.courtesyOf[0]
        : "";
  } else {
    officeContact = listing.print.officeContact.includes("nyc")
      ? listing.print.officeContact.replace(
          "sothebyshomes.com",
          "sothebysrealty.com"
        )
      : listing.print.officeContact;
  }

  return (
    <div className="foot-print-container">
      <div className="agents-logo">
        <AgentsV2 listing={listing} />
        <div className="print-logo-footer">
          <img src={logoSrc} alt="logo" />
        </div>
      </div>
      <div className="foot-print-brokerage">
        <div className="foot-print-brokerage-name">
          {listing.office && listing.office.name
            ? `${listing.office.name}\u00A0 | \u00A0`
            : ""}
        </div>
        <div className="foot-print-brokerage-contact"> {officeContact} </div>
      </div>
      <div className="print-legal-copy">
        <Disclaimer />
      </div>
    </div>
  );
};

export default FooterV2;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/footerv2.js